/* eslint-disable */
import React from 'react';
import Modal from 'react-modal';
import Select, { components } from 'react-select';
import closeIcon from '../../../../assets/images/x_icon_black.svg';

import './index.scss';
import utils from '../../../../lib/utils';
import history from '../../../../lib/history';

Modal.setAppElement('#root');

const DropdownIndicator = (props) =>
    components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
            <i className="material-icons custom">arrow_drop_down</i>
        </components.DropdownIndicator>
    );

const multiSelectdropdownCustomStyle = {
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#007bff' : 'white',
        padding: '10px',
        color: '#000',
        ':hover': {
            backgroundColor: '#f0f0f0',
        },
    }),
    menuList: (provided) => ({
        ...provided,
        maxHeight: 200,
        overflowY: 'auto',
    }),
    control: (base) => ({
        ...base,
        border: '1px solid #CFD0D1',
        padding: '6px',
        boxShadow: 'none',
        outline: 'none',
        '&:hover': {
            border: '1px solid #CFD0D1',
        },
    }),
    valueContainer: (base) => ({
        ...base,
        padding: '0px',
    }),
};

class SelectBusinessToAuth extends React.Component {
    constructor(props) {
        super(props);
        this.closeModal = this.closeModal.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.ref = React.createRef();
        this.triesref = React.createRef();
        this.selectRef = React.createRef(); // Add ref for the Select component
        this.state = {
            selectedBusiness: null,
            searchResults: [],
            isLoading: false,
            inputValue: '',
            menuIsOpen: false,
        };
        this.searchTimer = null;
    }

    async fetchData(searchTerm) {
        const { email, password } = this.props;
        try {
            this.setState({ isLoading: true });
            const basicAuthToken = btoa(`${email}:${password}`);
            // Replace with your actual API endpoint
            const response = await fetch(
                `${window.Config.API_URL}/bookingSWs/query?searchTerm=${encodeURIComponent(searchTerm)}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Basic ${basicAuthToken}`,
                    },
                }
            );
            const data = await response.json();

            // Transform data to react-select format { value, label }
            const searchResults = data.map(item => ({
                value: item.id,
                label: item.name,
                status: item.status
            }));

            this.setState({
                searchResults,
                isLoading: false,
                menuIsOpen: true,
            }, () => {
                // Restore focus after state update
                if (this.selectRef.current) {
                    this.selectRef.current.focus();
                }
            });
        } catch (error) {
            console.error('Error fetching data:', error);
            this.setState({
                isLoading: false,
                searchResults: []
            });
        }
    };

    // Handle input change with debouncing
    handleInputChange = (inputValue, { action }) => {
        // Only handle actual input changes, ignore other actions like menu-close, set-value, etc.
        if (action === 'input-change') {
            this.setState({ inputValue });

            // Clear previous timer
            if (this.searchTimer) {
                clearTimeout(this.searchTimer);
            }
            if (inputValue.trim()) {
                this.searchTimer = setTimeout(() => {
                    this.fetchData(inputValue);
                }, 800);
            } else {
                this.setState({ searchResults: [], menuIsOpen: false });
            }
        }
        // For all other actions, preserve the current inputValue
        return this.state.inputValue;
    };

    handleDropdownIndicatorClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const { inputValue, searchResults } = this.state;
        if (searchResults.length > 0) {
            this.setState({ menuIsOpen: !this.state.menuIsOpen }, () => {
                // Restore focus after toggling menu
                if (this.selectRef.current) {
                    setTimeout(() => {
                        this.selectRef.current.focus();
                    }, 0);
                }
            });
        }
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside = (event) => {
        if (
            this.triesref.current &&
            !this.triesref.current.contains(event.target)
        ) {
            this.setState({
                menuIsOpen: false,
            });
        }
    };

    // Handle selection change
    handleChange = (selectedOption) => {

        this.setState({ selectedOption });

        // Call parent component's onChange if provided
        if (this.props.onChange) {
            this.props.onChange(selectedOption);
        }
    };

    // Custom filter function to prevent default filtering
    filterOption = () => true;

    // Custom no options message - Updated to remove 4 character restriction
    noOptionsMessage = ({ inputValue }) => {
        return "No options found";
    };

    // Cleanup timer on unmount
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
        if (this.searchTimer) {
            clearTimeout(this.searchTimer);
        }
    }

    selectBusinessforLogin = (business, { action }) => {
        if (action === "clear") {
            this.setState({
                selectedBusiness: null,
                inputValue: "",
                searchResults: [],   // 🔑 reset results so arrow hides
                menuIsOpen: false,
            });
        } else {
            this.setState({
                selectedBusiness: business,
                inputValue: "",
                menuIsOpen: false,
            });
        }
    };

    closeModal() {
        this.setState({
            selectedBusiness: null,
            searchResults: [],
            isLoading: false,
            inputValue: '',
            menuIsOpen: false,
        })
        this.props.hideSelectBusiness();
    }

    clickOnSignUp = () => {
        const { email, password } = this.props;
        // this.props.getPricingPlans(null, null, email, password);
        utils.setCookie('authe', email);
        utils.setCookie('authp', password);
        history.push('/signup');
    }

    handleMenuClose = () => {
        this.setState({ menuIsOpen: false }, () => {
            // Restore focus when menu closes
            if (this.selectRef.current) {
                setTimeout(() => {
                    this.selectRef.current.focus();
                }, 0);
            }
        });
    }

    render() {
        const { modelopen, clickSignIn } = this.props;
        const { selectedBusiness, searchResults, isLoading, menuIsOpen, inputValue } = this.state;
        const displayValue = selectedBusiness;
        return (
            <div>
                <Modal
                    isOpen={modelopen}
                    onAfterOpen={this.afterOpenModal}
                    onRequestClose={this.closeModal}
                    className="Modal"
                    overlayClassName="Overlay"
                    contentLabel="Business Selection Modal"
                >
                    <div>
                        <div className="modal-header">
                            {/* <div className="title">Choose your option</div> */}
                            <button className="modal-close" onClick={this.closeModal}>
                                <img src={closeIcon}></img>
                            </button>
                            <div className="auth-action-form-container">
                                <div className="form-group business-selection" ref={this.triesref}>
                                    <label htmlFor="business_id">Select Business to Login</label>
                                    <Select
                                        ref={this.selectRef} // Add ref to Select component
                                        options={searchResults}
                                        onChange={this.selectBusinessforLogin}
                                        onInputChange={this.handleInputChange}
                                        onMenuClose={this.handleMenuClose}
                                        onBlur={() => { }}
                                        isLoading={isLoading}
                                        value={displayValue}
                                        inputValue={inputValue}
                                        menuIsOpen={menuIsOpen}
                                        closeMenuOnSelect={true}
                                        openMenuOnFocus={false}
                                        openMenuOnClick={false}
                                        className="form-group_business-field"
                                        components={{
                                            DropdownIndicator: (props) => {
                                                const shouldShowArrow = (searchResults && searchResults.length > 0) || this.state.selectedBusiness || this.state.inputValue;
                                                return (
                                                    <div
                                                        onClick={shouldShowArrow ? this.handleDropdownIndicatorClick : undefined}
                                                        style={{
                                                            visibility: shouldShowArrow ? 'visible' : 'hidden',
                                                            width: '20px', // Maintain consistent width
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}
                                                    >
                                                        <DropdownIndicator {...props} />
                                                    </div>
                                                );
                                            },
                                            IndicatorSeparator: () => null,
                                        }}
                                        styles={multiSelectdropdownCustomStyle}
                                        placeholder="Search business name or ID"
                                        isDisabled={isLoading}
                                        isClearable={true}
                                        getOptionLabel={(option) => `${option.label} (${option.value}${option.status ? ` - ${option.status}` : ''})`}
                                        // Add these props to maintain focus
                                        autoFocus={false}
                                        blurInputOnSelect={false}
                                        captureMenuScroll={false}
                                    />
                                    <button className="signin btn btn--primary btn--lg" disabled={!selectedBusiness} onClick={() => clickSignIn(selectedBusiness)}>LOGIN</button>
                                </div>
                                <div className="auth-action-form-container_divider">
                                    <span>OR</span>
                                </div>
                                <div className="form-group">
                                    <button className="signup btn btn--primary btn--lg" onClick={this.clickOnSignUp}>Sign Up</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {this.props.children}
                </Modal>
            </div>
        );
    }
}

export default SelectBusinessToAuth;
